import * as React from 'react';
import styles from './index.less';
import img_markdown from '@/assets/createVersion_markdown.png';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';

interface FResourceMarkdownEditorProps {
  style?: React.CSSProperties;

  onClickBtn?(): void;
}

function FResourceMarkdownEditor({ style, onClickBtn }: FResourceMarkdownEditorProps) {
  return (
    <>
      <div className={styles.markdownEditor} style={style}>
        <img src={img_markdown} alt={''} style={{ width: 56, height: 64 }} />
        <div style={{ height: 40 }} />
        <FComponentsLib.FContentText
          text={
            // 'markdown编辑器'
            FI18n.i18nNext.tAuto('newversion_tool_posteditor_title')
          }
          type={'additional2'}
        />
        <div style={{ height: 40 }} />
        <FComponentsLib.FRectBtn
          type={'primary'}
          onClick={() => {
            onClickBtn && onClickBtn();
          }}
        >
          {
            // 立即体验
            FI18n.i18nNext.tAuto('btn_add_new_post')
          }
        </FComponentsLib.FRectBtn>
      </div>
    </>
  );
}

export default FResourceMarkdownEditor;
